<template>
  <div class="orderOverStyle">
    <top-component></top-component>
    <div class="orderContent">
      <el-tabs @tab-click="tabHandleClick" style="margin:20px auto;">
        <el-tab-pane label="订单查询">
          <div class="dd">
            <div class="export_all">
              <Button size="small" type="primary" @click="exportOrder()">批量导出订单</Button>
              <Button size="small" v-if="adminState == '1'|| adminState == '0'" type="success"
                @click="exportAllOrder()">导出机构下所有订单</Button>
              <Button size="small" type="danger" @click="handleCommanddd()">订单导入</Button>
              <Button size="small" type="info" @click="handleCommand()">Marc数据转表格</Button>
              <Button size="small" type="warning" @click="converttabledatatomarc()">表格数据转Marc</Button>
              <Button size="small" type="primary" plain @click="externalprocurementmatching()">外采匹配</Button>
            </div>
            <el-table :data="tableData" style="width: 100%;margin-top: 15px;" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="48"></el-table-column>
              <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
              <el-table-column prop="createTime" label="订单日期" width="150" align="center"></el-table-column>
              <el-table-column prop="customOrderId" label="订单编号" width="180" align="center"></el-table-column>
              <el-table-column prop="goodsType" label="订单类型" align="center" width="100">
                <template slot-scope="scope">
                  <span v-if="Number(scope.row.goodsType) === 1">纸质书</span>
                  <span v-else-if="Number(scope.row.goodsType) === 2">电子书</span>
                  <span v-else>非书籍</span>
                </template>
              </el-table-column>
              <el-table-column prop="totalPrice" label="订单总价" align="right" width="100"></el-table-column>
              <el-table-column prop="submitter" label="加购人" width="100" align="center"></el-table-column>
              <el-table-column prop="remark" label="操作人" width="100" align="center"></el-table-column>
              <el-table-column prop="name" label="操作" width="330px">
                <template slot-scope="scope">
                  <el-link type="primary" @click="DetailOrder(scope.row.orderId)">查看详情</el-link>
                  <el-link type="primary" @click="OrderDao(scope.row.orderId, 1)">导出订单</el-link>
                  <el-link type="primary" @click="OrderDao(scope.row.orderId, 2)">导出MARC</el-link>
                  <el-link type="primary" @click="balanceOrder(scope.row.orderId, 0)" v-if="scope.row.balance == 0">审核</el-link>
                  <el-link type="primary" @click="balanceOrder(scope.row.orderId, 1)" v-if="scope.row.balance == 0">结算</el-link>
                  <el-link type="primary" @click="removeOrder(scope.row.orderId, 1)" v-if="scope.row.balance == 0">删除</el-link>
                  <span style="color: #0fc50f;vertical-align: middle;" v-if="scope.row.balance == 1">已审核</span>
                  <span style="color: #ff0000;vertical-align: middle;" v-if="scope.row.balance == 1">已结算</span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page.sync="pages.currentPage" :page-size="pages.pagesize" layout="prev, pager, next, jumper"
              :total="pages.total">
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="智能推送/书目下载">
          <div class="kj">
            <el-tabs v-model="booktab" type="card" @tab-click="booktypeHandleClick">
              <el-tab-pane label="可供社科" name="2018020915511601905"></el-tab-pane>
              <el-tab-pane label="可供科技" name="2018021014261407665"></el-tab-pane>
              <el-tab-pane label="地方版社科" name="2019022510133116882"></el-tab-pane>
              <el-tab-pane label="地方版科技" name="2019022510134016883"></el-tab-pane>
              <el-tab-pane label="可供高职" name="2018021014262407666"></el-tab-pane>
              <el-tab-pane label="可供少儿" name="2018021014263207669"></el-tab-pane>
              <!-- 修改：为三个排行榜分配唯一name -->
              <el-tab-pane label="馆配图书排行榜" name="rank-guanpei"></el-tab-pane>
              <el-tab-pane label="热门图书排行榜" name="rank-hot"></el-tab-pane>
              <el-tab-pane label="畅销图书排行榜" name="rank-best"></el-tab-pane>
            </el-tabs>
            <el-table :data="bookList" style="width: 100%;margin-top: 15px;">
              <el-table-column type="selection" width="55"></el-table-column>
              <!-- <el-table-column prop="listTitle" label="书目标题"></el-table-column> -->
              <el-table-column prop="listTitle" label="书目标题"></el-table-column>
              <el-table-column prop="listPeriods" label="期数"></el-table-column>
              <el-table-column prop="createDate" label="创建时间"></el-table-column>
              <el-table-column prop="name" label="操作">
                <template slot-scope="scope">
                  <el-link @click="downBook(scope.row)">下载</el-link>
                </template>
              </el-table-column>
            </el-table>
            <div style="display: flex;">
              <Button size="small" type="warning" @click="batchdownBook()">批量下载</Button>
              <el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
                :current-page.sync="currentPage" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="统计分析">
          <div>
            <div style="display: flex; flex-wrap: wrap;">
              <div ref="barChart" style="width: 580px; height: 400px;"></div>
              <div ref="barChart1" style="width: 620px; height: 400px;"></div>
            </div>
            <div style="display: flex; flex-wrap: wrap;">
              <div ref="barChart2" style="width: 580px; height: 400px;"></div>
              <div ref="barChart3" style="width: 620px; height: 400px;"></div>
            </div>
            <div style="display: flex; flex-wrap: wrap;">
              <div ref="barChart4" style="width: 580px; height: 400px;"></div>
              <div ref="barChart5" style="width: 620px; height: 400px;"></div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="智能筛选与匹配">
          <el-container class="full-height">
            <el-aside width="450px" class="aside-container">
              <el-tabs v-model="activeTab" type="border-card">
                <el-tab-pane label="对应关系管理" name="mapping">
                  <div class="tab-content">
                    <el-form label-width="120px">
                      <el-form-item label="中图法分类">
                        <el-tree :data="clcData" node-key="id" ref="clcTree" show-checkbox :props="{ label: 'label' }"></el-tree>
                      </el-form-item>
                      <el-form-item label="对应主题词">
                        <el-tag v-for="(tag, index) in newMapping.keywords" :key="'k-' + index" closable
                          @close="handleClose(tag, 'keywords')" type="info" class="keyword-tag">{{ tag }}</el-tag>
                        <el-input class="input-new-tag" v-if="keywordInputVisible" v-model="keywordInputValue"
                          ref="keywordTagInput" size="small" @keyup.enter.native="handleInputConfirm('keywords')"
                          @blur="handleInputConfirm('keywords')"></el-input>
                        <el-button v-else class="button-new-tag" size="small" @click="showInput('keywords')">添加主题词</el-button>
                      </el-form-item>
                      <el-form-item label="对应学科名称">
                        <el-tree :data="disciplineData" node-key="id" ref="disciplineTree" show-checkbox :props="{ label: 'label' }"></el-tree>
                      </el-form-item>
                      <el-form-item>
                        <el-button type="primary" @click="saveMapping" style="width: 100%;">保存对应关系</el-button>
                      </el-form-item>
                    </el-form>
                    <div class="divider-line"></div>
                    <div class="saved-mapping">
                      <h4>已保存的对应关系</h4>
                      <el-table :data="displayMappings" style="width: 100%" max-height="250">
                        <el-table-column prop="clcCodes" label="中图法分类" width="120"></el-table-column>
                        <el-table-column prop="keywords" label="主题词">
                          <template slot-scope="scope">
                            <el-tag v-for="tag in scope.row.keywords" :key="tag" size="small" type="success" class="keyword-tag-display">{{ tag }}</el-tag>
                          </template>
                        </el-table-column>
                        <el-table-column prop="disciplines" label="学科名称">
                          <template slot-scope="scope">
                            <el-tag v-for="tag in scope.row.disciplines" :key="tag" size="small" type="warning" class="keyword-tag-display">{{ tag }}</el-tag>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="图书筛选与剔除" name="filter">
                  <div class="tab-content">
                    <el-form label-width="120px">
                      <el-form-item label="中图法分类">
                        <el-cascader v-model="filterForm.clcCode" :options="clcData"
                          :props="{ checkStrictly: true, label: 'label', value: 'id', multiple: true }" clearable
                          placeholder="请选择" style="width: 100%;"></el-cascader>
                      </el-form-item>
                      <el-form-item label="学科名称">
                        <el-cascader v-model="filterForm.discipline" :options="disciplineData"
                          :props="{ checkStrictly: true, label: 'label', value: 'id', multiple: true }" clearable
                          placeholder="请选择" style="width: 100%;"></el-cascader>
                      </el-form-item>
                      <el-form-item>
                        <el-button type="primary" @click="autoFilter" style="width: 100%;">自动识别并剔除</el-button>
                      </el-form-item>
                    </el-form>
                    <div v-if="filteredCount !== null" class="result-summary">
                      已成功**识别并剔除** <span class="highlight">{{ filteredCount }}</span> 本不符合要求的图书。
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </el-aside>
            <el-main class="main-container">
              <div class="book-list-header">
                <h2>图书列表（共 {{ books.length }} 本）</h2>
                <div class="actions">
                  <el-button type="success" @click="resetData">重置数据</el-button>
                </div>
              </div>
              <el-table :data="books" style="width: 100%" class="book-table">
                <el-table-column prop="title" label="书名" min-width="180"></el-table-column>
                <el-table-column prop="author" label="作者" width="120"></el-table-column>
                <el-table-column prop="clcCode" label="中图法分类号" width="150"></el-table-column>
                <el-table-column prop="keywords" label="主题词" min-width="150">
                  <template slot-scope="scope">
                    <el-tag v-for="(tag, index) in scope.row.keywords" :key="index" size="small" type="info" class="keyword-tag-list">{{ tag }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="disciplines" label="学科名称" min-width="150">
                  <template slot-scope="scope">
                    <el-tag v-for="(tag, index) in scope.row.disciplines" :key="index" size="small" type="warning" class="keyword-tag-list">{{ tag }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="100">
                  <template slot-scope="scope">
                    <el-button type="danger" size="small" @click="manualRemove(scope.$index)">手动剔除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-main>
          </el-container>
        </el-tab-pane>
      </el-tabs>
      <el-dialog title="物流进度" :visible.sync="progessVisible" width="50%">
        <el-timeline>
          <el-timeline-item v-for="(activity, index) in progressInfo" :key="index" :timestamp="activity.time">
            {{ activity.context }}
          </el-timeline-item>
        </el-timeline>
      </el-dialog>
    </div>
    <bottom-component></bottom-component>
  </div>
</template>

<script>
import { allBooks } from '../../../src/dataJson/fullbooksData';
import { pcaTextArr } from "element-china-area-data";
import TopComponent from '../Components/TopComponentcopy.vue'
import BottomComponent from '../Components/BottomComponent.vue'
import { listOrders, exportOrder, exportAllOrder, exportMarc, balanceOrder, getremoveorder, publicationyearandmonthstatistics } from '@/api/pages'
import Cookies from 'js-cookie'
import FileSaver from 'file-saver';
import * as echarts from 'echarts';
import axios from 'axios';
import { Button } from 'element-ui'

const mockData = {
  clcData: [
    { id: 'A', label: '马克思主义、列宁主义、毛泽东思想、邓小平理论', children: [
      { id: 'A1', label: '马克思、恩格斯著作' },
      { id: 'A2', label: '列宁著作' },
      { id: 'A3', label: '斯大林著作' }
    ]},
    { id: 'B', label: '哲学、宗教', children: [
      { id: 'B1', label: '世界哲学' },
      { id: 'B2', label: '中国哲学' },
      { id: 'B3', label: '亚洲哲学' }
    ]},
    { id: 'C', label: '社会科学总论', children: [
      { id: 'C1', label: '社会科学理论与方法' },
      { id: 'C93', label: '管理学' }
    ]},
    { id: 'E', label: '军事', children: [
      { id: 'E1', label: '军事理论' }
    ]},
    { id: 'F', label: '经济', children: [
      { id: 'F0', label: '经济学' },
      { id: 'F1', label: '世界经济' }
    ]},
    { id: 'G', label: '文化、科学、教育、体育', children: [
      { id: 'G4', label: '教育' },
      { id: 'G63', label: '中小学教育' }
    ]},
    { id: 'I', label: '文学', children: [
      { id: 'I1', label: '世界文学' },
      { id: 'I2', label: '中国文学' },
      { id: 'I712', label: '小说' }
    ]},
    { id: 'J', label: '艺术', children: [
      { id: 'J1', label: '艺术理论' },
      { id: 'J2', label: '绘画' }
    ]},
    { id: 'T', label: '工业技术', children: [
      { id: 'TP', label: '自动化技术、计算机技术', children: [
        { id: 'TP3', label: '计算技术、计算机技术', children: [
          { id: 'TP31', label: '计算数学、程序设计' },
          { id: 'TP312', label: '程序设计' },
          { id: 'TP316', label: '算法' },
          { id: 'TP39', label: '信息处理、信息系统' }
        ]}
      ]}
    ]},
    { id: 'Z', label: '综合性图书', children: [
      { id: 'Z1', label: '丛书' },
      { id: 'Z2', label: '百科全书' }
    ]}
  ],
  disciplineData: [
    { id: 'CS', label: '计算机科学', children: [
      { id: 'CS1', label: '软件工程' },
      { id: 'CS2', label: '人工智能' },
      { id: 'CS3', label: '数据科学' }
    ]},
    { id: 'PH', label: '哲学', children: [
      { id: 'PH1', label: '中国哲学' },
      { id: 'PH2', label: '西方哲学' }
    ]},
    { id: 'LS', label: '文学', children: [
      { id: 'LS1', label: '古典文学' },
      { id: 'LS2', label: '现代文学' }
    ]},
    { id: 'EC', label: '经济学', children: [
      { id: 'EC1', label: '宏观经济学' },
      { id: 'EC2', label: '微观经济学' }
    ]},
    { id: 'HI', label: '历史学', children: [
      { id: 'HI1', label: '中国历史' },
      { id: 'HI2', label: '世界历史' }
    ]},
    { id: 'LA', label: '法学' },
    { id: 'EN', label: '教育学' },
    { id: 'MD', label: '医学' },
    { id: 'AR', label: '艺术学' },
    { id: 'MT', label: '数学' },
    { id: 'PY', label: '物理学' },
    { id: 'CH', label: '化学' },
  ],
  keywordMapping: {
    'TP312': { keywords: ['编程', 'Java', 'Python'], disciplines: ['计算机科学', '软件工程'] },
    'TP316': { keywords: ['算法', '数据结构'], disciplines: ['计算机科学', '数学'] },
    'I712': { keywords: ['小说', '文学'], disciplines: ['文学', '艺术学'] },
    'G63': { keywords: ['教育学', '中小学'], disciplines: ['教育学'] },
    'C93': { keywords: ['管理', '企业管理'], disciplines: ['管理学', '经济学'] },
  }
};

export default {
  name: 'HelloWorld',
  data() {
    return {
      activeTab: 'mapping',
      clcData: mockData.clcData,
      disciplineData: mockData.disciplineData,
      keywordMapping: mockData.keywordMapping,
      allBooks: allBooks,
      books: [],
      newMapping: {
        clcCodes: [],
        keywords: [],
        disciplines: []
      },
      keywordInputVisible: false,
      keywordInputValue: '',
      filterForm: {
        clcCode: [],
        discipline: []
      },
      filteredCount: null,
      pcaTextArr,
      selectedOptions: [],
      progessVisible: false,
      adminState: Cookies.get('adminState'),
      tabIndex: 0,
      pages: {
        currentPage: 1,
        pagesize: 10,
        total: 100
      },
      tableData: [],
      booktab: '2018020915511601905',
      bookList: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      orderIdArr: [],
      progressInfo: [
        {
          time: "2024-04-09 12:39:56",
          ftime: "2024-04-09 12:39:56",
          context: "已签收,签收人是 汤小洋 先生/女士，如有疑问请联系派件员阿奇(13805148888)如您未收到此快递，请拨打投诉电话:15294207777，感谢使用申通快递，期待再次为您服务",
          location: null,
        },
        {
          time: "2024-04-08 08:46:54",
          ftime: "2024-04-08 08:46:54",
          context: "上海浦东寒亭营业厅-寒亭阿奇(13805148888)-派件中",
          location: null,
        },
        {
          time: "2024-04-08 08:38:57",
          ftime: "2024-04-08 08:38:57",
          context: "已到达-上海浦东寒亭营业厅",
          location: null,
        },
      ]
    }
  },
  mounted() {
    this.ApiData()
    this.getBookList();
    this.initBarChart();
    this.initBarChart2();
    this.initBarChart3();
  },
  computed: {
    displayMappings() {
      return Object.keys(this.keywordMapping).map(key => {
        return {
          clcCodes: key,
          keywords: this.keywordMapping[key].keywords,
          disciplines: this.keywordMapping[key].disciplines,
        };
      });
    },
  },
  created() {
    this.books = [...this.allBooks];
  },
  methods: {
    saveMapping() {
      const checkedClcNodes = this.$refs.clcTree.getCheckedNodes();
      const checkedDisciplineNodes = this.$refs.disciplineTree.getCheckedNodes();
      if (checkedClcNodes.length === 0 || (this.newMapping.keywords.length === 0 && checkedDisciplineNodes.length === 0)) {
        this.$message.warning('请选择中图法分类并至少添加一个主题词或学科名称');
        return;
      }
      const clcCodes = checkedClcNodes.map(node => node.id);
      const disciplines = checkedDisciplineNodes.map(node => node.label);
      clcCodes.forEach(code => {
        this.$set(this.keywordMapping, code, {
          keywords: [...this.newMapping.keywords],
          disciplines: [...disciplines],
        });
      });
      this.newMapping.keywords = [];
      this.newMapping.disciplines = [];
      this.$refs.clcTree.setCheckedKeys([]);
      this.$refs.disciplineTree.setCheckedKeys([]);
      this.$message.success('对应关系保存成功！');
    },
    handleClose(tag) {
      this.newMapping.keywords.splice(this.newMapping.keywords.indexOf(tag), 1);
    },
    showInput() {
      this.keywordInputVisible = true;
      this.$nextTick(_ => { this.$refs.keywordTagInput.$refs.input.focus(); });
    },
    handleInputConfirm() {
      let inputValue = this.keywordInputValue.trim();
      if (inputValue) {
        this.newMapping.keywords.push(inputValue);
      }
      this.keywordInputVisible = false;
      this.keywordInputValue = '';
    },
    autoFilter() {
      const { clcCode, discipline } = this.filterForm;
      let originalBookCount = this.books.length;
      let filteredBooks = this.allBooks;
      if (clcCode && clcCode.length > 0) {
        const clcCodesToKeep = clcCode.map(path => path[path.length - 1]);
        filteredBooks = filteredBooks.filter(book => clcCodesToKeep.includes(book.clcCode));
      }
      if (discipline && discipline.length > 0) {
        const disciplinesToKeep = discipline.map(path => path[path.length - 1]);
        filteredBooks = filteredBooks.filter(book => book.disciplines.some(d => disciplinesToKeep.includes(d)));
      }
      filteredBooks = filteredBooks.filter(book => {
        const mapping = this.keywordMapping[book.clcCode];
        if (!mapping) return false;
        const hasValidKeyword = book.keywords.some(k => mapping.keywords.includes(k));
        const hasValidDiscipline = book.disciplines.some(d => mapping.disciplines.includes(d));
        return hasValidKeyword || hasValidDiscipline;
      });
      this.books = filteredBooks;
      this.filteredCount = originalBookCount - this.books.length;
      this.$message.success('图书已根据要求自动剔除！');
    },
    manualRemove(index) {
      this.books.splice(index, 1);
      this.$message.info('已手动剔除该图书');
    },
    resetData() {
      this.books = [...this.allBooks];
      this.keywordMapping = JSON.parse(JSON.stringify(mockData.keywordMapping));
      this.filteredCount = null;
      this.filterForm.clcCode = [];
      this.filterForm.discipline = [];
      this.activeTab = 'mapping';
      this.$message.success('数据已重置到初始状态');
    },
    getBookList() {
      let vm = this;
      // 排行榜配置映射
      const rankConfig = {
        'rank-guanpei': { 
          groupGid: '2018020915511601905', 
          page: 1, 
          replaceStr: '三新采访', 
          newStr: '馆配图书排行榜',
          removeStr: '社科'
        }, // 可供社科 第6页
        'rank-hot': { 
          groupGid: '2018021014261407665', 
          page: 1, 
          replaceStr: '三新采访', 
          newStr: '热门图书排行榜',
          removeStr: '科技'
        }, // 可供科技 第3页
        'rank-best': { 
          groupGid: '2018021014262407666', 
          page: 1, 
          replaceStr: '三新采访', 
          newStr: '畅销图书排行榜',
          removeStr: '高职'
        } // 可供高职 第3页
      };

      // 判断是否为排行榜标签页
      if (rankConfig[vm.booktab]) {
        const { groupGid, page, replaceStr, newStr, removeStr } = rankConfig[vm.booktab];
        axios.post('/sxtucaihui/userlogin/action/bookorderlist', {
          groupGid: groupGid,
          page: page,
          rows: vm.pageSize,
        }).then(res => {
          if (res.status) {
            let resdata = JSON.parse(res.data.data);
            // 修改书目标题：替换指定字符串并移除特定文字
            vm.bookList = resdata.result.data.map(item => ({
              ...item,
              listTitle: item.listTitle
                .replace(replaceStr, newStr) // 替换前缀
                .replace(removeStr, '') // 移除特定文字
            }));
            vm.total = resdata.result.totalRecord;
          }
        }).catch(err => {});
        return;
      }

      // 原接口逻辑（其他标签页）
      axios.post('/sxtucaihui/userlogin/action/bookorderlist', {
        groupGid: vm.booktab,
        page: vm.currentPage,
        rows: vm.pageSize,
      }).then(res => {
        if (res.status) {
          let resdata = JSON.parse(res.data.data);
          vm.bookList = resdata.result.data;
          vm.total = resdata.result.totalRecord;
        }
      }).catch(err => {});
    },
    booktypeHandleClick(tab, event) {
      this.currentPage = 1;
      this.pageSize = 20;
      this.getBookList(); // 切换标签时重新加载数据
    },
    downBook(row) {
      window.open('http://www.ytzhihui.com/ecp/down.download?filePath=' + row.attachUrl, '_blank');
    },
    batchdownBook() {},
    handleChange() {
      console.log(this.selectedOptions, 'selectedOptions');
    },
    handleSelectionChange(val) {
      let vm = this;
      vm.orderIdArr = [];
      val.forEach((ele, index) => {
        vm.orderIdArr.push(ele.orderId);
      });
    },
    exportOrder() {
      let vm = this;
      if (vm.orderIdArr.length > 0) {
        vm.OrderDao(vm.orderIdArr.join(), 1);
      } else {
        vm.$message({
          message: '至少选择一条订单数据才可批量导出！',
          type: 'warning'
        });
      }
    },
    tabHandleClick(tab, event) {
      let vm = this;
      vm.tabIndex = tab.index;
      vm.tableData = [];
      if (vm.tabIndex == 3) {
        vm.getBookList();
      } else {
        vm.ApiData();
      }
    },
    handleCommanddd() {
      if (Cookies.get("token")) {
        this.$router.push({ name: "ImportOrder3" });
      } else {
        this.$router.push({ name: "Login" });
      }
    },
    handleCommand() {
      if (Cookies.get("token")) {
        this.$router.push({ name: "ImportOrder" });
      } else {
        this.$router.push({ name: "Login" });
      }
    },
    converttabledatatomarc() {
      if (Cookies.get("token")) {
        this.$router.push({ name: "ImportMarc" });
      } else {
        this.$router.push({ name: "Login" });
      }
    },
    externalprocurementmatching() {
      if (Cookies.get("token")) {
        this.$router.push({ name: "externalprocurementmatching" });
      } else {
        this.$router.push({ name: "Login" });
      }
    },
    ApiData() {
      var obj = {
        userId: Cookies.get('UserID'),
        pageNum: this.pages.currentPage,
        pageSize: this.pages.pagesize,
      }
      listOrders(obj).then(response => {
        this.tableData = response.data.list
        this.pages.total = response.data.total
      })
    },
    removeOrder(orderId) {
      this.$confirm('此操作将永久删除该订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        getremoveorder({ orderId: orderId }).then(response => {
          if (response.code == 200) {
            this.$message({ type: 'success', message: '删除成功!' });
            this.ApiData();
          } else {
            this.$message({ type: 'error', message: '删除失败，请稍后重试。' });
          }
        }).catch(error => {
          console.error('API call failed:', error);
          this.$message({ type: 'error', message: '删除失败，网络请求异常。' });
        });
      }).catch(() => {
        this.$message({ type: 'info', message: '已取消删除' });
      });
    },
    balanceOrder(orderId, type) {
      let vm = this,
        str = '',
        obj = {
          orderId: orderId,
          balance: 1
        };
      type == 0 ? str = "审核通过" : str = "结算";
      vm.$confirm("确定要" + str + "吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        balanceOrder(obj).then(res => {
          if (res.status) {
            vm.$message({ message: str + "成功！", type: 'success' });
            vm.ApiData();
          }
        });
      }).catch(() => { });
    },
    DetailOrder(orderId) {
      this.$router.push({ name: 'OrderDetail', query: { orderId: orderId } })
    },
    async exportAllOrder() {
      axios.post('sxtucaihui/order/action/exportAllStream',
        { orgId: Cookies.get('orgGid') },
        {
          responseType: 'blob',
          headers: { 'datasource': Cookies.get('logintype'), 'source': Cookies.get('source') }
        })
        .then(response => {
          const blob = new Blob([response.data], { type: 'text/plain;charset=utf-8' });
          FileSaver.saveAs(blob, '全部订单.xlsx');
          this.$message({ message: "导出成功", type: "success", duration: 2000 });
        }).catch(error => {
          this.$message({ message: "导出失败", type: "warning", duration: 2000 });
        });
    },
    async OrderDao(orderId, type) {
      if (type == 1) {
        axios.post('sxtucaihui/order/action/exportOrderStream',
          { orderId: orderId, userName: Cookies.get('name') },
          {
            responseType: 'blob',
            headers: { 'datasource': Cookies.get('logintype'), 'source': Cookies.get('source') }
          }).then(response => {
            const blob = new Blob([response.data], { type: 'text/plain;charset=utf-8' });
            FileSaver.saveAs(blob, '订单汇总.xlsx');
            this.$message({ message: "导出成功", type: "success", duration: 2000 });
          }).catch(error => {
            this.$message({ message: "导出失败", type: "warning", duration: 2000 });
          });
      } else {
        axios.post('sxtucaihui/order/action/exportMarcStream',
          { orderId: orderId, userName: Cookies.get('name') },
          {
            responseType: 'blob',
            headers: { 'datasource': Cookies.get('logintype'), 'source': Cookies.get('source') }
          })
          .then(response => {
            const blob = new Blob([response.data], { type: 'text/plain;charset=utf-8' });
            FileSaver.saveAs(blob, 'MARC.iso');
            this.$message({ message: "导出成功", type: "success", duration: 2000 });
          }).catch(error => {
            this.$message({ message: "导出失败", type: "warning", duration: 2000 });
          });
      }
    },
    handleClose(done) {
      this.$confirm('确认关闭？').then(_ => { done(); }).catch(_ => { });
    },
    bcaddress() {
      this.$message({ message: "保存成功！", type: "warning", duration: 2000 });
    },
    async initBarChart() {
      let barChart = echarts.init(this.$refs.barChart);
      let barChart1 = echarts.init(this.$refs.barChart1);
      let obj = { name: "cbny", orgid: Cookies.get('orgGid') }
      let res = await publicationyearandmonthstatistics(obj)
      if (res.code == '200') {
        this.initBarChartdata = res.data
        if (this.initBarChartdata.length > 0) {
          var xAxisData = this.initBarChartdata.map(function (item) { return item.name; });
          var seriesData = this.initBarChartdata.map(function (item) { return item.total; });
          var seriesData1 = this.initBarChartdata.map(function (item) { return item.totalPrice; });
        }
      }
      let barOption = {
        title: { text: '出版年月统计(册)', left: 'center' },
        tooltip: {},
        xAxis: { type: 'category', data: xAxisData },
        yAxis: { type: 'value' },
        series: [{ data: seriesData, type: 'bar', name: '册数' }]
      };
      let barOption1 = {
        title: { text: '出版年月统计(码洋)', left: 'center' },
        tooltip: {},
        xAxis: { type: 'category', data: xAxisData },
        yAxis: { type: 'value' },
        series: [{ data: seriesData1, type: 'bar', name: '码洋' }]
      };
      barChart.setOption(barOption);
      barChart1.setOption(barOption1);
    },
    async initBarChart2() {
      let lineChart2 = echarts.init(this.$refs.barChart2);
      let lineChart3 = echarts.init(this.$refs.barChart3);
      let obj = { name: "ztf", orgid: Cookies.get('orgGid') }
      let res = await publicationyearandmonthstatistics(obj)
      if (res.code == '200') {
        this.initBarChartdata = res.data
        if (this.initBarChartdata.length > 0) {
          var xAxisData = this.initBarChartdata.map(function (item) { return item.name; });
          var seriesData = this.initBarChartdata.map(function (item) { return item.total; });
          var seriesData1 = this.initBarChartdata.map(function (item) { return item.totalPrice; });
        }
      }
      let lineOption1 = {
        title: { text: '学科专业(册)', left: 'center' },
        tooltip: {},
        xAxis: { type: 'category', data: xAxisData },
        yAxis: { type: 'value' },
        series: [{ data: seriesData, type: 'line', name: '册数' }]
      };
      let lineOption2 = {
        title: { text: '学科专业(码洋)', left: 'center' },
        tooltip: {},
        xAxis: { type: 'category', data: xAxisData },
        yAxis: { type: 'value' },
        series: [{ data: seriesData1, type: 'line', name: '码洋' }]
      };
      lineChart2.setOption(lineOption1);
      lineChart3.setOption(lineOption2);
    },
    async initBarChart3() {
      let lineChart2 = echarts.init(this.$refs.barChart4);
      let lineChart3 = echarts.init(this.$refs.barChart5);
      let obj = { name: "username", orgid: Cookies.get('orgGid') }
      let res = await publicationyearandmonthstatistics(obj)
      if (res.code == '200') {
        this.initBarChartdata = res.data
        if (this.initBarChartdata.length > 0) {
          var xAxisData = this.initBarChartdata.map(function (item) { return item.name; });
          var seriesData = this.initBarChartdata.map(function (item) { return { value: item.total, name: item.name }; });
          var seriesData1 = this.initBarChartdata.map(function (item) { return { value: item.totalPrice, name: item.name }; });
        }
      }
      let lineOption1 = {
        title: { text: '荐购(数量)', left: 'center' },
        tooltip: { trigger: 'item' },
        series: [{ data: seriesData, type: 'pie', name: '册数' }]
      };
      let lineOption2 = {
        title: { text: '荐购(码洋)', left: 'center' },
        tooltip: { trigger: 'item' },
        series: [{ data: seriesData1, type: 'pie', name: '码洋' }]
      };
      lineChart2.setOption(lineOption1);
      lineChart3.setOption(lineOption2);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.pages.currentPage = val
      this.ApiData()
    },
    handleSizeChange2(val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val;
      this.getBookList();
    },
    handleCurrentChange2(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getBookList()
    }
  },
  components: { TopComponent, BottomComponent, Button }
}
</script>

<style scoped lang="scss">
.orderOverStyle {
  width: 100%;
  background-color: #f9f9f9;
  overflow-x: hidden;
}

.orderContent {
  width: 1250px;
  margin-left: calc(50% - 600px);

  .export_all {
    padding: 10px;
    margin-top: 15px;
    background-color: #fff;
  }

  .orderChange {
    height: 60px;
    width: 1200px;
    margin: 30px auto 20px auto;
  }
}

.orderTitle {
  height: 40px;
  display: flex;
  align-items: center;
  margin-left: 30px;
  padding-top: 30px;
}

.address-form {
  max-width: 400px;
  margin: auto;
}

.address-form label {
  display: block;
  margin-bottom: 5px;
}

.address-form select,
.address-form textarea {
  width: 100%;
  padding: 8px;
  margin-bottom: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
}

.address-form button {
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.address-form button:hover {
  background-color: #0056b3;
}

.full-height {
  height: 100vh;
}

.aside-container {
  padding: 20px;
  background-color: #f5f7fa;
  border-right: 1px solid #ebeef5;
}

.main-container {
  padding: 20px;
}

.tab-content {
  padding: 10px;
}

.keyword-tag {
  margin: 5px;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

.button-new-tag {
  margin-left: 10px;
}

.divider-line {
  border-top: 1px dashed #dcdfe6;
  margin: 20px 0;
}

.saved-mapping {
  margin-top: 20px;
}

.saved-mapping h4 {
  margin-bottom: 10px;
}

.keyword-tag-display,
.keyword-tag-list {
  margin: 2px;
}

.book-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.result-summary {
  margin-top: 20px;
  padding: 15px;
  background-color: #e6f7ff;
  border-left: 5px solid #1890ff;
}

.highlight {
  font-weight: bold;
  color: #1890ff;
  font-size: 1.2em;
}

.el-table__row.red-row {
  background: #fef0f0;
}
</style>


// WEBPACK FOOTER //
// src/views/ChildPages/Order-Over.vue